module.exports = __webpack_public_path__ + "static/media/banner-4.59cd48d0.mp4";